const BASE_URL = "https://app.artharlem.org/api/v1";
export const IMG_URL = "https://app.artharlem.org/hoast/uploads/";

export const LOGINADMIN = BASE_URL + "/auth/login";
export const SIGNUP = BASE_URL + "/auth/signup";
export const LOGOUT = BASE_URL + "/auth/logout";
export const REFRESH_TOKEN_API = BASE_URL + "/auth/refresh-token";
export const VERIFY_OTP = BASE_URL + "/auth/verify-otp";
export const RESEND_OTP = BASE_URL + "/auth/resend-otp";
export const FORGOT_PASSWORD_OTP = BASE_URL + "/auth/forgot-password-verify-otp";
export const FORGOT_PASSWORD = BASE_URL + "/auth/forgot-password";
export const GET_ART_MEDIUMS = BASE_URL + "/art/get-art-medium";
export const GET_STATUS = BASE_URL + "/art/get-art-status";
export const ACCOUNT_SETUP = BASE_URL + "/auth/account-setup";
export const RESET_PASSWORD = BASE_URL + "/auth/reset-password";
export const LOGIN_THIRD_PARTY = BASE_URL + "/auth/signup-by-thirdparty";

// Artwork
export const ARTWORK_LIST = BASE_URL + "/art/get-artist-arts";
export const ARTWORK_CREATE = BASE_URL + "/art/add-art";
export const ARTWORK_UPDATE = BASE_URL + "/art/edit-art";
export const ARTWORK_DELETE = BASE_URL + "/art/delete-art";

// Messages
export const GET_CHATS = BASE_URL + "/chat/list-chats";
export const GET_CHAT_MESSAGES = BASE_URL + "/chat/get-chat-messages";
export const SEND_MESSAGE = BASE_URL + "/chat/send-message-v2";

// Profile
export const PROFILE_UPDATE = BASE_URL + "/core/update-profile";
export const PROFILE_GET = BASE_URL + "/core/get-user-profile";
export const UPDATE_STUDIO = BASE_URL + "/core/update-studio";
export const GET_NOTIFICATIONS = BASE_URL + "/notification/get-notifications";
export const GET_NOTIFICATION_COUNT = BASE_URL + "/notification/get-notification-unread-count";

// Subscription
export const FREE_SUBSCRIBE = BASE_URL + "/subscription/create-free-plan";
export const GET_INVOICES = BASE_URL + "/subscription/get-invoice-history";
export const GET_SUBSCRIPTION_PLAN = BASE_URL + "/admin/admin-get-plans";
export const CHECKOUT_SUBSCRIPTION = BASE_URL + "/subscription/create-check-session";
export const GET_CHECKOUT_SUBSCRIPTION_PLAN = BASE_URL + "/subscription/get-available-plans";

// Terms & Conditions
export const GET_TERMS_CONDITIONS = BASE_URL + "/legal/get-legal-content";